<template>
    <div>
		<Card :bordered="false" :dis-hover="true">
			<transition name="fade">
				<Row v-if="mainTable.sarchCardShow" :gutter="16">
					<Col span="24">
					<search-card :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
						:table-search="mainTable.tableSearch"
                        :colSpan="4" />
					</Col>
				</Row>
			</transition>
			<Row :gutter="16">
				<Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">分账管理</span>
                            <Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
                                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        </div>
                        <div class="right-bar">

                        </div>
                    </div>
				</Col>
			</Row>
			<Row :gutter="16" class="main">
                <Col span="24">
                    <pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getMainTableRecords"
                        :autoHeight = "true"
                        summaryLabelField = "seedFarmName"
                        :summaryFields="['receiveQuantity',
                                            'totalReceiveQuantity',
                                            'preSaleValue',
                                            'saleDiscountValue',
                                            'refundAmount',
                                            'compensationDetailValue',
                                            'saleRealValue',
                                            'combineCommission',
                                            'webDev',
                                            'seedlingService',
                                            'guangzhouIT',
                                            'promotionDept',
                                            'voucherAmount']"
                        :totalSummaryFieldDatas="mainTable.sumData"
                        :showPage="true" />
                </Col>
            </Row>
		</Card>
	</div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import PaginationTable from '@/components/pagination-table/pagination-table.vue';
import { getThisMonthStart, getTodayDateString, calculate } from '@/libs/logic';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import { getTransactionAllocationList } from '@/api/modules/stat-analyze/customer-analyze';
export default {
    name: 'TransactionAllocation',
    components: {
        PaginationTable,
        SearchCard
    },
    data() {
        return {
            selectDates: [],
            mainTable: {
                columns: [
                    /* {
                        title: '定金单号',
                        key: 'depositBillRecordCode',
                        align: 'center',
                        width: 120
                    }, */
                    {
                        title: '发货单号',
                        key: 'preSaleDeliveryRecordCode',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '会员账号',
                        key: 'userName',
                        align: 'center',
                        width: 80
                    },
                    {
                        title: '会员姓名',
                        key: 'userPersonName',
                        align: 'center'
                    },
                    {
                        title: '苗场编号',
                        key: 'seedFarmCode',
                        align: 'center'
                    },
                    {
                        title: '苗场名称',
                        key: 'seedFarmName',
                        align: 'center'
                    },
                    {
                        title: '客户经理账号',
                        key: 'managerCode',
                        align: 'center'
                    },
                    {
                        title: '客户经理',
                        key: 'managerName',
                        align: 'center'
                    },
                    {
                        title: '商品编号',
                        key: 'productCode',
                        align: 'center'
                    },
                    {
                        title: '商品名',
                        key: 'productName',
                        align: 'center'
                    },
                    {
                        title: '大类',
                        key: 'mainCategoryName',
                        align: 'center'
                    },
                    {
                        title: '小类',
                        key: 'subCategoryName',
                        align: 'center'
                    },
                    /* {
                        title: '周次',
                        key: 'weekSeq',
                        align: 'center'
                    },
                    {
                        title: '收款量',
                        key: 'receiveQuantity',
                        align: 'center'
                    },
                    {
                        title: '发货量',
                        key: 'totalReceiveQuantity',
                        align: 'center'
                    }, */
                    {
                        title: '销售金额',
                        key: 'preSaleValue',
                        align: 'center'
                    },
                    {
                        title: '优惠金额',
                        key: 'saleDiscountValue',
                        align: 'center'
                    },
                    {
                        title: '代金券',
                        key: 'voucherAmount',
                        align: 'center'
                    },
                    {
                        title: '退货金额',
                        key: 'refundAmount',
                        align: 'center'
                    },
                    {
                        title: '退款金额',
                        key: 'compensationDetailValue',
                        align: 'center'
                    },
                    {
                        title: '有效金额',
                        key: 'saleRealValue',
                        align: 'center'
                    },
                    {
                        title: '客户经理提成',
                        key: 'combineCommission',
                        align: 'center'
                    },
                    {
                        title: '网站开发',
                        key: 'webDev',
                        align: 'center'
                    },
                    {
                        title: '种苗网服务部',
                        key: 'seedlingService',
                        align: 'center'
                    },
                    {
                        title: 'IT部',
                        key: 'guangzhouIT',
                        align: 'center'
                    },
                    {
                        title: '缤纷推广部',
                        key: 'promotionDept',
                        align: 'center'
                    },
                    {
                        title: '发货日期',
                        key: 'preSaleDeliveryRecordDeliveryDate',
                        align: 'center',
                        render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate)
                    }
                ],
                data: [],
                sumData: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '苗场', type: 'Input', value: '', name: 'concat(seedFarm.seedFarmCode, seedFarm.seedFarmName)', sql: 'like' },
                    { label: '客户经理', type: 'Input', value: '', name: 'manager.userName', sql: 'like' },
                    { label: '日期', type: 'Daterange', value: this.getCurrentMonthDateRange(), name: 'delivery.preSaleDeliveryRecordDeliveryDate', sql: 'dateBetween' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    methods: {
        init(){
            search.globalAddFilterConditionKey(this.mainTable.tableSearch, "delivery.preSaleDeliveryRecordDeliveryDate", "=", JSON.stringify(this.getCurrentMonthDateRange()));
            this.getTransactionAllocation();
        },
        getMainTableRecords(){
            this.getTransactionAllocation();
        },
        getTransactionAllocation(reset = false){
            this.mainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);

            }
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            getTransactionAllocationList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    this.mainTable.sumData = res.data.sumRecord;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style>
</style>
